// extracted by mini-css-extract-plugin
module.exports =  {"fixedLayout":"r6K5eTQsEbB1CWYWHv5w","truncate":"BsRr_YjDutbI9cc7puFh"};